import React from 'react'
import { imgUrlConverter } from '../../util/util'

export const CardSection = React.memo(({ appData:{customerdata}, appData:{storedata} }) => {

	const ringSizerData = customerdata?.filter(data => data.contentType === "SchoolStoreRingSizer")[0]
	const tryOnData = customerdata?.filter(data => data.contentType === "SchoolStoreTryOn")[0]
	
	if ( (storedata?.schoolStoreTryOn && tryOnData) || (storedata?.schoolStoreRingSizer && ringSizerData) ) {
		return (
			<div className={`card-section${(storedata.schoolStoreRingSizer?.hasRingSizeBanner && ringSizerData && storedata.schoolStoreTryOn?.tryOnBannerUrl && tryOnData) ? " items-2" : ""}`}>
				{ storedata.schoolStoreRingSizer?.hasRingSizeBanner && ringSizerData && 
					<div className="item">
						<div className="img-wrapper">
							<div className="bg"></div>
							<img src={imgUrlConverter(ringSizerData.imageUrl)} alt={ringSizerData.imageAltText} loading="lazy" />
						</div>
						<div className="content">
							<h4>{ringSizerData.title}</h4>
							<div className="text" dangerouslySetInnerHTML={{__html: ringSizerData.content}}></div>
							<div><a href={ringSizerData.documentUrl} target="_blank" className="btn btn-primary btn-primary--ghost" rel="noopener noreferrer">Download PDF</a></div>
						</div>
					</div>
				}
				{ storedata.schoolStoreTryOn?.tryOnBannerUrl && tryOnData && 
					<div className="item">
						<div className="img-wrapper">
							<div className="bg"></div>
							<img src={imgUrlConverter(tryOnData.imageUrl)} alt={ringSizerData.imageAltText} loading="lazy" />
						</div>
						<div className="content">
							<h4>{tryOnData.title}</h4>
							<div className="text" dangerouslySetInnerHTML={{__html: tryOnData.content}}></div>
							<div><a href={storedata.schoolStoreTryOn.tryOnBannerUrl} target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-primary--ghost">Try Now</a></div>
						</div>
					</div>
				}
			</div>
		)
	} else {
		return null
	}
})

// export default React.memo()